import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { ReportSearchInputProps } from "models/propTypes/reportsPropTypes";
//#endregion
//#region components
import { InputAdornment, TextField } from "@mui/material";
import useSearchContext from "./context/useContext";
import Icon from "../icon";
import { useDebouncedCallback } from "use-debounce";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const ReportSearchInput: React.FC<ReportSearchInputProps> = (props) => {
  const { placeholder } = props;
  const [internalValue, setInternalValue] = React.useState<string>("");
  const searchContext = useSearchContext();

  const debouncedHandleOnChange = useDebouncedCallback((value?: string) => {
    searchContext?.setSearchText(value);
  }, 700);

  const onChange = (event: React.ChangeEvent<any>) => {
    event.persist && event.persist();
    const target = event.target;
    setInternalValue(target.value);
    debouncedHandleOnChange(target.value);
  };

  React.useEffect(() => {
    if (internalValue !== searchContext?.searchText) setInternalValue(searchContext?.searchText ?? "");
  }, [searchContext?.searchText]);

  return (
    <TextField
      value={internalValue}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end" className={cssExports.inputAdornedStart}>
            <Icon icon={IconDefinitionConstants.WSearch} className={cssExports.inputIcon} />
          </InputAdornment>
        ),
        classes: {
          root: cssExports.searchButtonInput,
        },
      }}
      onChange={onChange}
      classes={{
        root: cssExports.searchButton,
      }}
      placeholder={placeholder ?? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Search)}
    />
  );
};

export default ReportSearchInput;
